import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import AuthLayout, { Field, Message } from './AuthLayout';
import Button from '../components/Button';
import { accent, tx } from '../theme';

export default function SignUp() {
  const { signUp } = useAuth();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      setError('Please enter your first and last name.');
      return;
    }
    if (password.length < 8) {
      setError('Password needs to be at least 8 characters.');
      return;
    }
    setBusy(true); setError('');
    const { error } = await signUp(email, password, {
      firstName: firstName.trim(), lastName: lastName.trim(),
    });
    setBusy(false);
    if (error) setError(error.message);
    else setDone(true);
  }

  if (done) {
    return (
      <AuthLayout eyebrow="Almost there" title="Confirm your email."
        intro={`We've sent a confirmation link to ${email}. Click it and you're in.`}>
        <Message tone="success">
          You can close this tab — the link opens Groundwork for you.
        </Message>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      eyebrow="Get started"
      title="Create your account."
      footer={<>Already have one? <Link to="/login" style={{ color: accent.lime }}>Log in</Link></>}
    >
      <Message tone="error">{error}</Message>

      <form onSubmit={handleSubmit}>
        <Field label="First name" type="text" value={firstName} autoComplete="given-name"
          onChange={e => setFirstName(e.target.value)} placeholder="Alex" required />
        <Field label="Last name" type="text" value={lastName} autoComplete="family-name"
          onChange={e => setLastName(e.target.value)} placeholder="Marsh" required />
        <Field label="Email" type="email" value={email} autoComplete="email"
          onChange={e => setEmail(e.target.value)} placeholder="you@email.com" required />
        <Field label="Password" type="password" value={password} autoComplete="new-password"
          onChange={e => setPassword(e.target.value)} placeholder="At least 8 characters" required />
        <Button type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? 'Creating account…' : 'Create account'}
        </Button>
      </form>

      <p style={{ fontSize: 12.5, color: tx.faint, marginTop: 16, textAlign: 'center' }}>
        We'll only email you about Groundwork. Nothing else.
      </p>
    </AuthLayout>
  );
}
